import React from "react";
import { FormattedMessage } from "react-intl";

export const AccountPage: React.FC = () => {
  return (
    <div>
      <FormattedMessage id='AccountPage.header' />
    </div>
  );
};

export default AccountPage;
